import { render, staticRenderFns } from "./GuestPersonRegister.vue?vue&type=template&id=ff0f34c0&scoped=true"
import script from "./GuestPersonRegister.vue?vue&type=script&lang=js"
export * from "./GuestPersonRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0f34c0",
  null
  
)

export default component.exports